import React, { CSSProperties, MouseEventHandler, MouseEvent } from "react";
import { StaticImage } from "gatsby-plugin-image";
import Button from "../Button";
import * as styles from "./style.module.css";
import Pen from "../../images/svg/pen.svg";
import Share from "../../images/svg/share.svg";
import Reward from "../../images/svg/reward.svg";
import { howItWorks } from "../../data/data.js";
import LinkButton from "../LinkButton";
import { HowItWorksProps } from "../interface/interface";

const HowItWorks: React.FC<HowItWorksProps> = ({ trainer, home, future }) => (
  <section className={trainer ? styles.darkhowitworks : styles.howitworks} style={ future ? { background:'#FAF9F5'}: {}}>
    {trainer && (
      <div className={styles.content}>
        <h2 className={styles.darktitle}>How it Works</h2>
        <div className={styles.descrs}>
          {(howItWorks as { title: string; copy: string }[]).map((item, i) => (
            <div key={item.title} className={styles.descritem}>
              <img
                className={styles.descricon}
                src={i === 0 ? Pen : i === 1 ? Share : Reward}
              />
              <h3 className={styles.descrtitle}>{item.title}</h3>
              <p className={styles.descrcopy}>{item.copy}</p>
            </div>
          ))}
        </div>
        <LinkButton
          text="GET STARTED"
          href="/trainer-form/"
          className={styles.darkhowitworksbtn}
        />
      </div>
    )}

    {future && (
      <>
        <h2 className={styles.title}>How Your Gainful System Works</h2>
        <div className={styles.steps}>
          <div className={styles.step}>
            <StaticImage
              className={styles.icon}
              alt="Take the quiz image"
              src="../../images/howitworks/step1.png"
            />
            <h4>Take the quiz</h4>
            <div>
              Take the quiz to find products tailored specifically for you.
            </div>
          </div>
          <div className={styles.step}>
            <StaticImage
              className={styles.icon}
              alt="your unique system of Protein, Hydration or Pre-Workout"
              src="../../images/howitworks/step2.png"
            />
            <h4>RECEIVE YOUR PERSONALIZED FORMULAS</h4>

            <div>
              See results from your personalized regimen including your unique
              system of Protein, Hydration or Pre-Workout.
            </div>
          </div>
          <div className={styles.step}>
            <StaticImage
              className={styles.icon}
              alt="Registered Dietitian image"
              src="../../images/howitworks/step3.png"
            />
            <h4>CHAT WITH YOUR FREE REGISTERED DIETITIAN</h4>
            <div>
              Enjoy ongoing support from your assigned Registered Dietitian.
            </div>
          </div>
        </div>
        <Button
          text="40% off for Future Members"
          onClick={() => {
            window.location.href = "/quiz-start-future/";
          }}
          style={{ display: "flex", margin: "6px auto" }}
        />
      </>
    )}

    {home && (
      <>
        <h2 className={styles.title}>
          Performance is personal.
          <br />
          We create nutrition systems tailored to your body.
        </h2>
        <div className={styles.steps}>
          <div className={styles.step}>
            <StaticImage
              className={styles.icon}
              alt="Take the quiz image"
              src="../../images/howitworks/step1.png"
            />
            <div>
              Take the quiz to find products tailored specifically for you.
            </div>
          </div>
          <div className={styles.step}>
            <StaticImage
              className={styles.icon}
              alt="your unique system of Protein, Hydration or Pre-Workout"
              src="../../images/howitworks/step2.png"
            />
            <div>
              See results from your personalized regimen including your unique
              system of Protein, Hydration or Pre-Workout.
            </div>
          </div>
          <div className={styles.step}>
            <StaticImage
              className={styles.icon}
              alt="Registered Dietitian image"
              src="../../images/howitworks/step3.png"
            />
            <div>
              Enjoy ongoing support from your assigned Registered Dietitian.
            </div>
          </div>
        </div>
        <Button
          text="Make Your Move"
          onClick={() => {
            window.location.href = "/quiz/";
          }}
          style={{ display: "flex", margin: "6px auto" }}
        />
      </>
    )}
  </section>
);

export default HowItWorks;
